export default {"src":"/_next/static/media/NT-card-number-pre-01-nov-2020.3d80d639.svg","height":142,"width":222,"blurWidth":0,"blurHeight":0};